import React from 'react';
import { Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const PhotoBoothShowcase = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 px-4 bg-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-logo-teal/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 right-10 w-40 h-40 bg-accent-warm/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Side - Print Photo Booth */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-logo-teal/20 to-accent-warm/20 rounded-2xl transform rotate-3 group-hover:rotate-6 transition-transform duration-300"></div>
            <div className="relative bg-white p-4 rounded-2xl shadow-2xl transform -rotate-2 group-hover:rotate-0 transition-transform duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_nostalgic-shots-14/artifacts/2wux55i9_digital%20photo%20booth.jpg"
                alt="Vintage Camera Box Print Photo Booth"
                className="w-full h-auto rounded-lg shadow-lg"
              />
              {/* Vintage stamp effect */}
              <div className="absolute -top-4 -right-4 bg-accent-warm text-white px-6 py-3 rounded-full shadow-lg transform rotate-12 font-bold">
                <Sparkles className="w-5 h-5 inline mr-1" />
                Classic
              </div>
            </div>
          </div>
          
          {/* Content Side */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="text-logo-teal font-bold text-sm tracking-wider uppercase bg-logo-teal-light px-4 py-2 rounded-full">
                Vintage Open Air Photo Booth - Print
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-logo-navy vintage-title leading-tight">
              Classic Print Booth
              <span className="block text-logo-teal">Instant Keepsakes</span>
            </h2>
            
            <p className="text-lg text-logo-navy-light leading-relaxed">
              Our authentic vintage print photo booth delivers instant photo strip prints! 
              Guests get physical keepsakes on the spot - perfect tangible memories.
            </p>
            
            {/* Simplified Pricing */}
            <div className="bg-gradient-to-br from-logo-teal/10 to-accent-warm/10 p-8 rounded-2xl border-2 border-logo-teal/30">
              <div className="text-center mb-6">
                <p className="text-logo-navy-light text-sm mb-2">Starting at</p>
                <p className="text-5xl font-bold text-logo-teal">$599</p>
                <p className="text-logo-navy-light text-sm mt-2">2-4 hours available</p>
              </div>
              
              <Button 
                onClick={scrollToContact}
                className="w-full bg-logo-teal hover:bg-logo-teal-dark text-white py-6 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-105 font-bold"
              >
                Book Print Booth
              </Button>
            </div>
            
            <div className="pt-4">
              <ul className="space-y-3">
                <li className="flex items-center gap-3 text-logo-navy-light">
                  <div className="w-6 h-6 bg-logo-teal rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-xs font-bold">✓</span>
                  </div>
                  <span>Instant photo strip prints on the spot</span>
                </li>
                <li className="flex items-center gap-3 text-logo-navy-light">
                  <div className="w-6 h-6 bg-logo-teal rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-xs font-bold">✓</span>
                  </div>
                  <span>Requires electric outlet</span>
                </li>
                <li className="flex items-center gap-3 text-logo-navy-light">
                  <div className="w-6 h-6 bg-logo-teal rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-xs font-bold">✓</span>
                  </div>
                  <span>Classic nostalgic experience</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhotoBoothShowcase;